export default "__VITE_ASSET__f442ab13__"